import { type FunctionComponent, type ReactNode } from 'react';
import { FormattedMessage } from 'react-intl';

import { ClockIcon } from '@trello/nachos/icons/clock';

import { BoardSwitcherTile } from './BoardSwitcherTile';
import { BoardSwitcherTiles } from './BoardSwitcherTiles';
import { BoardSwitcherTilesLoadingSkeleton } from './BoardSwitcherTilesLoadingSkeleton';
import { ExpandSection } from './ExpandSection';
import { useBoardSwitcher } from './useBoardSwitcher';

import * as styles from './RecentBoards.module.less';

const MAX_RECENT_BOARDS = 8;

export const RecentBoards: FunctionComponent = () => {
  const { recentBoards, recentLoading } = useBoardSwitcher();

  const boards = recentBoards.slice(0, MAX_RECENT_BOARDS);

  let contents: ReactNode;

  if (recentLoading) {
    contents = <BoardSwitcherTilesLoadingSkeleton />;
  } else if (boards.length === 0) {
    contents = (
      <div className={styles.emptyState}>
        <FormattedMessage
          id="templates.board_switcher.no-recent-boards"
          defaultMessage="No recent boards."
          description="Text shown when there are no recent boards"
        />
      </div>
    );
  } else {
    contents = (
      <BoardSwitcherTiles>
        {boards.map(({ id }) => (
          <BoardSwitcherTile key={id} boardId={id} section="recent" />
        ))}
      </BoardSwitcherTiles>
    );
  }

  return (
    <ExpandSection
      id="recent"
      title={
        <FormattedMessage
          id="templates.board_switcher.recent"
          defaultMessage="Recent"
          description="Title of recent workspaces section on the board switcher"
        />
      }
      customIcon={<ClockIcon />}
      isExpandedByDefault
      testId="board-switcher-recent-boards"
    >
      {contents}
    </ExpandSection>
  );
};
